export default __webpack_public_path__ + "static/world–desktop-f0f866c87805c373e207c73b802599d6.jpg";